<script setup lang="ts">
import type { ComponentMinisterialBadgesProps } from "./ComponentMinisterialBadges.props"

defineProps<ComponentMinisterialBadgesProps>()
</script>

<template>
  <template v-for="(Badge, index) in Badges" :key="index">
    <AppLink :to="Badge.ministerialLink">
      <UtilsWrapperImage
        v-if="Badge.image"
        v-bind="Badge.image"
        :key="Badge?.image?.image?.url || index"
        :class="[classImage, 'h-[110px] max-w-full']"
      />
    </AppLink>
  </template>
</template>
